import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";

interface WorkPermitStatusFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
  loading: boolean;
}

export function WorkPermitStatusFields({
  profile,
  setProfile,
  readOnly,
  loading
}: WorkPermitStatusFieldsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <Label htmlFor="entry_date">Einreisedatum</Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Gib das Datum deiner Einreise nach Deutschland an</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Input
          disabled={readOnly}
          loading={loading}
          type="date"
          id="entry_date"
          value={
            profile?.entry_date
              ? new Date(profile.entry_date).toISOString().split("T")[0]
              : ""
          }
          onChange={(e) => {
            setProfile((prev: any) => ({
              ...prev,
              entry_date: e.target.value
            }));
          }}
          className="w-full"
        />
      </div>
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <Label htmlFor="residence_permit_status">
            Aufenthaltstitel Status
          </Label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Wähle den aktuellen Status deines Aufenthaltstitels aus</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <Select
          disabled={readOnly}
          value={profile?.residence_permit_status}
          onValueChange={(value) =>
            setProfile({
              ...profile!,
              residence_permit_status: value
            })
          }
        >
          <SelectTrigger loading={loading}>
            <SelectValue placeholder="Status auswählen" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="not_applied">Nicht beantragt</SelectItem>
            <SelectItem value="applied">Beantragt</SelectItem>
            <SelectItem value="granted">Erteilt</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
